import React, { useEffect, useState } from "react";
import MainSlider from "../components/partials/home/MainSlider";
import Story from "../components/partials/home/Story";
import ParallaxSlider from "../components/partials/home/ParallaxSlider";
import BeautySection from "../components/partials/home/BeautySection";
import Business from "../components/partials/home/Business";
// import LookSection from "../components/partials/home/LookSection";
import ImageWithLeftCard from "../components/partials/home/ImageWithLeftCard";
import BlogsSection from "../components/partials/home/BlogsSection";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { Variables } from "../variables";
import Layout from "../layouts/Layout";

const Home = () => {
  const navigate = useNavigate();

  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "ar");
  const [windowSize, setWindowSize] = useState(window.innerWidth > 991);
  const [content, setContent] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // handle window resize
  useEffect(() => {
    const handleResize = () => setWindowSize(window.innerWidth > 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // poll for language cookie changes
  useEffect(() => {
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "ar";
      setLanguage((prevLang) =>
        prevLang !== currentLang ? currentLang : prevLang
      );
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const directionClass = language === "en" ? "text-left" : "text-right";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const buttonNavigation = () => {
    navigate("/about-me");
  };

  // fetch content
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const url =
          Variables.API_URL +
          "Rasha/Client/Page/1?isEnglish=" +
          (language === "en");

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result?.message || "Failed to fetch content");
        }

        if (isMounted) {
          setContent(Array.isArray(result) ? result : []);
        }
      } catch (err) {
        if (isMounted && err.name !== "AbortError") {
          setError(err.message || "Something went wrong");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [language]);

  // --- Loader ---
  if (loading) {
    return (
      <div style={styles.loaderWrap}>
        <div style={styles.spinner} />
      </div>
    );
  }

  // --- Error ---
  if (error) {
    return (
      <div style={styles.errorBox}>
        {error}
      </div>
    );
  }

  // --- Main Layout ---
  return (
    <Layout>
      {content.map((c) => {
        const key =
          c.WidgetId ?? `${c.WidgetTypeId}-${c.WidgetValue?.Id ?? Math.random()}`;

        if (parseInt(c.WidgetTypeId) === 2 && parseInt(c.WidgetValue.StyleId) === 1) {
          return (
            <MainSlider
              key={key}
              subTitle={language === "en" ? c.WidgetValue.TextLine1 : c.WidgetValue.TextLine1Ar}
              RedirectUrl={c.WidgetValue.RedirectUrl}
              button={language === "en" ? c.WidgetValue.ButtonText : c.WidgetValue.ButtonTextAr}
              title={language === "en" ? c.WidgetValue.TextLine2 : c.WidgetValue.TextLine2Ar}
              backgroundImage={Variables.API_PUBLISHED + c.WidgetValue.ImageUrl}
            />
          );
        } else if (parseInt(c.WidgetTypeId) === 2 && parseInt(c.WidgetValue.StyleId) === 2) {
          return windowSize ? (
            <ParallaxSlider
              key={key}
              backgroundImage={Variables.API_PUBLISHED + c.WidgetValue.ImageUrl}
            />
          ) : (
            <React.Fragment key={key} />
          );
        } else if (parseInt(c.WidgetTypeId) === 2 && parseInt(c.WidgetValue.StyleId) === 3) {
          return (
            <Business
              key={key}
              title={language === "en" ? c.WidgetValue.TextLine1 : c.WidgetValue.TextLine1Ar}
              buttonText={language === "en" ? c.WidgetValue.ButtonText : c.WidgetValue.ButtonTextAr}
              RedirectUrl={c.WidgetValue.RedirectUrl}
              backgroundImage={Variables.API_PUBLISHED + c.WidgetValue.ImageUrl}
            />
          );
        } else if (parseInt(c.WidgetTypeId) === 1) {
          return (
            <Story
              key={key}
              storyContent={
                language === "en"
                  ? (c.WidgetValue.Body || "").split("\n")
                  : (c.WidgetValue.BodyAr || "").split("\n")
              }
              language={language}
              storyContentAR={(c.WidgetValue.BodyAr || "").split("\n")}
              storyContentEN={(c.WidgetValue.Body || "").split("\n")}
              storyTitle={language === "en" ? c.WidgetValue.Title : c.WidgetValue.TitleAr}
              buttonText={language === "en" ? c.WidgetValue.ButtonText : c.WidgetValue.ButtonTextAr}
              directionClass={directionClass}
              bodyClass=""
              image={Variables.API_PUBLISHED + c.WidgetValue.ImageUrl}
              buttonNavigation={buttonNavigation}
            />
          );
        } else if (parseInt(c.WidgetTypeId) === 3 && parseInt(c.WidgetValue.TypeId) === 1) {
          return (
            <BeautySection
              key={key}
              title={language === "en" ? c.WidgetValue.Title : c.WidgetValue.TitleAr}
              button={language === "en" ? "Learn more" : "اعرف المزيد"}
              language={language}
              ButtonUrl1={c.WidgetValue.ButtonUrl1}
              ButtonUrl2={c.WidgetValue.ButtonUrl2}
              ButtonUrl3={c.WidgetValue.ButtonUrl3}
              ImageUrl1={Variables.API_PUBLISHED + c.WidgetValue.ImageUrl1}
              ImageUrl2={Variables.API_PUBLISHED + c.WidgetValue.ImageUrl2}
              ImageUrl3={Variables.API_PUBLISHED + c.WidgetValue.ImageUrl3}
            />
          );
        } else if (parseInt(c.WidgetTypeId) === 3 && parseInt(c.WidgetValue.TypeId) === 2) {
          return (
            <BlogsSection
              key={key}
              title={language === "en" ? c.WidgetValue.ImageText1 : c.WidgetValue.ImageText1Ar}
              button1={language === "en" ? c.WidgetValue.ButtonText2 : c.WidgetValue.ButtonText2Ar}
              button2={language === "en" ? c.WidgetValue.ButtonText3 : c.WidgetValue.ButtonText3Ar}
              blogs={[
                { caption: <>{c.WidgetValue.ImageText2}</>, link: c.WidgetValue.ButtonUrl2 },
                { caption: <>{c.WidgetValue.ImageText3}</>, link: c.WidgetValue.ButtonUrl3 },
              ]}
            />
          );
        } else if (parseInt(c.WidgetTypeId) === 6) {
          const t = {
            en: {
              title: c.WidgetName,
              heading: c.WidgetValue.Title,
              paragraph: c.WidgetValue.Body,
              button: c.WidgetValue.ButtonText,
            },
            ar: {
              title: c.WidgetName,
              heading: c.WidgetValue.TitleAr,
              paragraph: c.WidgetValue.BodyAr,
              button: c.WidgetValue.ButtonTextAr,
            },
          };
          return (
            <ImageWithLeftCard
              key={key}
              link={c.WidgetValue.ButtonUrl}
              t={t}
              image={Variables.API_PUBLISHED + c.WidgetValue.ImageUrl}
            />
          );
        } else return null;
      })}

      {/* <LookSection /> */}
    </Layout>
  );
};

const styles = {
  loaderWrap: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: 48,
    height: 48,
    border: "4px solid rgba(0,0,0,0.1)",
    borderTopColor: "#000",
    borderRadius: "50%",
    animation: "spin 0.9s linear infinite",
  },
  errorBox: {
    margin: 16,
    padding: "12px 16px",
    border: "1px solid #f3c2c2",
    background: "#fff5f5",
    color: "#b00020",
    borderRadius: 8,
  },
};

// inject keyframes
if (typeof document !== "undefined" && !document.getElementById("home-spin-kf")) {
  const styleEl = document.createElement("style");
  styleEl.id = "home-spin-kf";
  styleEl.innerHTML = `@keyframes spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(styleEl);
}

export default Home;
